import { isDefined } from "@clipboard-health/util-ts";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { type TierType } from "@src/appV2/redesign/Tiers/api/schema";
import { useGetTiers } from "@src/appV2/redesign/Tiers/api/useGetTiers";
import { useGetWorker } from "@src/appV2/Worker/api/useGetWorker";

export function useGetTierType(): {
  tierType: TierType;
  isGetTiersSuccess: boolean;
  isTiersEnabled: boolean;
} {
  const { enabled: isTiersEnabled } = useCbhFlag(CbhFeatureFlag.CONFIG_TIERS, {
    defaultValue: { enabled: false },
  });
  const { data: worker } = useGetWorker();
  const { data: tiers, isSuccess: isGetTiersSuccess } = useGetTiers(
    { workerIds: [worker?.userId ?? ""] },
    { enabled: isDefined(worker?.userId) && isTiersEnabled }
  );
  const tierType = tiers?.data[0]?.attributes.type ?? "SILVER";
  return { tierType, isGetTiersSuccess, isTiersEnabled };
}
